import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { ProjectElement } from '../../../resources/element/project-element.interface';
import { ConstantsService } from '../../../utilities/constants/constants.service';
import { ConstantsStatusType } from '../../../utilities/constants/constants.interface';
import { FormControl } from '@angular/forms';
import { ElementService } from '../../../resources/element/element.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

/**
 * Dropdown with element status.
 */
@Component({
  selector: 'sg2-element-status',
  templateUrl: './element-status.component.html',
  styleUrls: ['./element-status.component.less']
})
export class ElementStatusComponent implements  OnDestroy, OnInit {

  /** Active element. */
  @Input() element: ProjectElement;

  /** Whether to show form label. */
  @Input() label: boolean;

  /** Status constants. */
  public statuses: ConstantsStatusType[];

  /** Current status. */
  public status: ConstantsStatusType;

  /** Status form. */
  public form: FormControl;

  /** Unsubscribe hook. */
  private _destroy$ = new Subject<any>();

  constructor(
    private constantsService: ConstantsService,
    public elementService: ElementService
  ) {
    this.statuses = constantsService.getStatusTypes();
  }

  ngOnInit() {
    this.form = new FormControl(this.element.status);
    this.elementService.element$.pipe(
      takeUntil(this._destroy$)
    ).subscribe(elements => {
      this.element = elements.find(e => e.identifier === this.element.identifier);
      this.status = this.statuses.find(s => s._id === this.element.status);
    });
  }

  ngOnDestroy() {
    this._destroy$.next();
    this._destroy$.complete();
  }

  /**
   * Set status.
   *
   * @param statusId The id of the status to set.
   */
  public setStatus(statusId: ProjectElement['status']): void {
    this.status = this.statuses.find(s => s._id === statusId);
    this.elementService.setStatus(this.element, this.status._id);
  }
}
